import {emotionStyled} from '@packages/utilities/styled';

export const STACK_GAP = '--component-gap';

export const STACK_STYLES = {
  display: 'flex',
  flexWrap: 'nowrap',
  gap: `var(${STACK_GAP}, 8px)`,
} as const;

export const HSTACK_STYLES = {
  ...STACK_STYLES,
  alignItems: 'center',
  flexDirection: 'row',
  justifyContent: 'start',
} as const;

export const VSTACK_STYLES = {
  ...STACK_STYLES,
  alignItems: 'stretch',
  flexDirection: 'column',
  justifyContent: 'start',
} as const;

export const STACK_VARIANTS = {
  // We do not allow `-reverse` direction stacks, so `flex-start` & `flex-end` are the same as `start` and `end`.
  // See the Box Alignment positional argument spec for more details:
  // https://www.w3.org/TR/css-align/#positional-values
  align: {
    start: {
      alignItems: 'start',
    },
    center: {
      alignItems: 'center',
    },
    stretch: {
      alignItems: 'stretch',
    },
    end: {
      alignItems: 'end',
    },
    baseline: {
      alignItems: 'baseline',
    },
  },
  // We do not allow `-reverse` direction stacks for accessibility reasons, since they make the DOM order not the same as the visual order.
  direction: {
    column: {
      flexDirection: 'column',
    },
    row: {
      flexDirection: 'row',
    },
  },
  justify: {
    start: {
      justifyContent: 'start',
    },
    center: {
      justifyContent: 'center',
    },
    'space-between': {
      justifyContent: 'space-between',
    },
    'space-around': {
      justifyContent: 'space-around',
    },
    'space-evenly': {
      justifyContent: 'space-evenly',
    },
    end: {
      justifyContent: 'end',
    },
  },
  isFullHeight: {
    true: {
      height: '100%',
    },
  },
  isFullWidth: {
    true: {
      width: '100%',
    },
  },
  shouldWrap: {
    true: {
      flexWrap: 'wrap',
    },
  },
  shouldSetAutoHeight: {
    true: {
      height: 'auto',
    },
  },
} as const;

export const STACK_DEFAULT_VARIANTS = {
  align: 'center',
  direction: 'row',
  justify: 'start',
} as const;

// We use cssVars to have a single class for all `Stack` components.
export const StackView = emotionStyled('div')(STACK_STYLES, {
  componentName: 'Stack',
  variants: STACK_VARIANTS,
  defaultVariants: STACK_DEFAULT_VARIANTS,
});

export const HStackView = emotionStyled('div')(STACK_STYLES, {
  componentName: 'HStack',
  variants: STACK_VARIANTS,
  defaultVariants: STACK_DEFAULT_VARIANTS,
});

export const VStackView = emotionStyled('div')(STACK_STYLES, {
  componentName: 'VStack',
  variants: STACK_VARIANTS,
  defaultVariants: STACK_DEFAULT_VARIANTS,
});
